import {
    SET_FETCH_DEPLOYED_REGIONS_REQUEST,
    SET_FETCH_DEPLOYED_REGIONS_SUCCESS,
    SET_FETCH_DEPLOYED_REGIONS_ERROR,
} from './../../../../constants/closeLoop/apmDashboard/regions/regionsConstants';

// Commented one represents the actual co-ordinates of the respective location.
const regions = [
    {
        markerOffset: -30,
        name: "North Virginia",
        code: "us-east-1",
        coordinates: [-84.00382951550085, 39.63791161432807]
//        coordinates: [37.4316, 78.6569]
    },
    {
        markerOffset: -30,
        name: "Ohio",
        code: "us-east-2",
//        coordinates: [40.4167, -82.9167]
        coordinates: [-83.20026964235582, 47.98228617756773]
    },
    {
        markerOffset: -30,
        name: "California",
        code: "us-west-1",
//        coordinates: [37.7749, -122.4194]
        coordinates: [-115.94914619187867, 34.32934259609788]
    },
    {
        markerOffset: -30,
        name: "Oregon",
        code: "us-west-2",
        coordinates: [-117.2902363093036, 42.31883787261252]
//        coordinates: [45.5200, -122.6819]
    },
    {
        markerOffset: -30,
        name: "Canada",
        code: "ca-central-1",
//        coordinates: [43.6532, -79.3832]
        coordinates: [-114.33455192720547, 59.33780776644144]
    },
    {
        markerOffset: -30,
        name: "Mumbai",
        code: "ap-south-1",
//        coordinates: [19.0760, 72.8777]
        coordinates:  [74.92668917811464, 19.43279488511456]
    },
    {
        markerOffset: -30,
        name: "Seoul",
        code: "ap-northeast-2",
//        coordinates: [37.5665, 126.9780]
        coordinates: [126.75010632853305, 37.9957991724535]
    },
    {
        markerOffset: -30,
        name: "Singapore",
        code: "ap-southeast-1",
//        coordinates: [1.3521, 103.8198]
        coordinates: [102.4710339353133, 2.915278485591954]
    },
    {
        markerOffset: -30,
        name: "Sydney",
        code: "ap-southeast-2",
//        coordinates: [-33.8688, 151.2093]
        coordinates: [148.5037207343746, -32.01959784897829]
    },
    {
        markerOffset: -30,
        name: "Tokyo",
        code: "ap-northeast-1",
//        coordinates: [35.6895, 139.6917]
        coordinates: [139.7622569947946, 35.88892281210079]
    },
    {
        markerOffset: -30,
        name: "Frankfurt",
        code: "eu-central-1",
//        coordinates: [50.1147, 8.6821]
        coordinates: [11.457639492822475, 50.35157538003841]

    },
    {
        markerOffset: -30,
        name: "Ireland",
        code: "eu-west-1",
        coordinates: [-7.056085635459961, 53.419721425289396]
//        coordinates: [53.4129, -8.2439]
    },
    {
        markerOffset: -30,
        name: "London",
        code: "eu-west-2",
        coordinates: [-0.7797514473849791, 52.79550107242927]
//        coordinates: [51.5074, -0.1278]
    },
    {
        markerOffset: -30,
        name: "Paris",
        code: "eu-west-3",
//        coordinates: [48.8566, 2.3522]
        coordinates: [4.612473398123462, 47.92578688359381]
    },
    {
        markerOffset: -30,
        name: "Sao Paulo",
        code: "sa-east-1",
//        coordinates: [-23.5505, -46.6333]
        coordinates:  [-47.95300012526382, -16.367434502770877]
    }
];

const initialState = {
    loading: false,
    regions: [],
    error: ''
}

export const deployedRegionsReducer = (state=initialState, action) => {
    switch (action.type) {
        case SET_FETCH_DEPLOYED_REGIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                regions: [],
            }

        case SET_FETCH_DEPLOYED_REGIONS_SUCCESS:
            // Fetching specific region markers/location.
            const markers = action.payload.map((regionName) => {
                const regionInfo = regions.find((item) => regionName === item['code']);
                return regionInfo;
            })
            return {
                ...state,
                loading: false,
                regions: markers,
                error: ''
            }

        case SET_FETCH_DEPLOYED_REGIONS_ERROR:
            return {
                ...state,
                loading: false,
                regions: [],
                error: action.payload,
            }

        default:
            return state;
    }
}

